import React, { useState } from 'react';
import useAuth from '../hooks/useAuth';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate, useLocation } from 'react-router-dom';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

import axios from '../apis/Axios';
const LOGIN_URL = 'api/User/login';
const LOGOUT_URL = 'api/User/logout';

export default function Login() {
    const axiosPrivate = useAxiosPrivate();
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');

    // set errors
    const [errors, setErrors] = useState({});

    const handleSubmit = async (e) => {
        // prevent default behavior of the form (prevent reloading)
        e.preventDefault();

        setErrors({});

        const data = {
            username: username,
            password: password
        };

        // error message
        var msg = '';
        
        if (validate()) {     
            try {
                const res = await axios.post(LOGIN_URL,
                    JSON.stringify({ username, password }),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );

                const userID = res.data.userID;
                const role = res.data.role;           
                setAuth({ userID, username, role });
                setUsername('');
                setPassword('');
                navigate(from, { replace: true });
            } catch (err) {
                if (!err?.response) {
                    msg = 'Server is not responding!';
                    console.log(msg);
                    errors.server = msg;
                } else if (err.response?.status === 400) {
                    msg = 'Bad request!';
                    console.log(msg);
                    errors.server = msg;
                } else if (err.response?.status === 401) {
                    msg = 'Unauthorized';
                    console.log(err.response?.data);
                    console.log(msg);
                    err.response?.data.errorText !== '' ? errors.server = msg + ': ' + err.response?.data.errorText : errors.server = msg;
                } else {
                    msg = 'Login unsuccessful!';
                    console.log(msg);
                    errors.server = msg;
                }
            }
            finally {
                setErrors(errors);
                setUsername('');
                setPassword('');
            }
            
        }
    }

    const validate = () => {
        var errors = {};
        errors.username = username !== '' ? '' : 'Please enter username!';
        errors.password = password !== '' ? '' : 'Please enter your password!';

        setErrors(errors);

        return Object.values(errors).every(item => item === '');
    }

    const logout = async () => {
        try {
            const res = await axiosPrivate.post(
            LOGOUT_URL
            );
        } catch (err) {
            console.log('Logout unsuccessful: ', err);
        } finally {
            // clear the state
            setAuth({});
            setErrors({});
            navigate('/');
        }
    };

    return (
        <>
        <div>
            <div>
                <span>
                    <label class='header h2 mt-5'>Login</label>
                    <i class='bi bi-box-arrow-in-right h2 me-2'></i>
                </span>
                <div class='login-buttons-top'>
                    <a href='/register'>
                        <button class='btn btn-outline-dark me-2'>Sign up</button>
                    </a>
                    <a href='/user-settings'>
                        <button class='btn btn-outline-dark me-2'>User Settings</button>
                    </a>
                </div>
            </div>
            <div class='login-page'>
                <form onSubmit={ handleSubmit }>
                    <div class='login-form'>
                        <label class='login-page-label'>
                            Login
                        </label>
                        <input 
                            type='text' 
                            class='form-control mb-2 ms-2' 
                            onChange = { (e) => setUsername(e.target.value) } 
                            value = { username }
                            maxLength={50} 
                        />
                        { errors.username && <div class='error-text'> { errors.username } </div> }
                        <label class='login-page-label'>
                            Password
                        </label>
                        <input 
                            type='password' 
                            class='form-control mb-3 ms-2' 
                            onChange = { (e) => setPassword(e.target.value) } 
                            value = { password } 
                            maxLength={50}
                        />
                        { errors.password && <div class='error-text'> { errors.password } </div> }
                        { errors.server && <div class='error-message' > { errors.server } </div> }
                    </div>
                    <button class='btn btn-outline-dark me-2 mt-2' type='submit'>Log in</button>
                    <button class='btn btn-dark me-2 mt-2' onClick={ logout }>Log out</button>
                </form>
            </div>
        </div>
        </>
    );
}